var $ = jQuery;


function getTextWidth(txt) {
  var $elm = $('<span>'+txt+'</span>').prependTo('body');
  var elmWidth = $elm.width();
  $elm.remove();
  return elmWidth;
}

function centerSelect($elm) {
  var optionWidth = getTextWidth($elm.children(':selected').html());
  var emptySpace =   $elm.width()- optionWidth;
  $elm.css('text-indent', (emptySpace/2) - 10);// -10 for some browers to remove the right toggle control width
}


function selectCenter() {

  function center() {
    // on start
    $('.js-select-center').each(function() {
      centerSelect($(this));
    });
    // on change
    $('.js-select-center').on('change', function() {
      centerSelect($(this));
    });
  }

  center();

  $(window).resize(function() {
    center();
  });
}

export { selectCenter };

